import React from 'react';

import classes from './AirlineRefundable.scss';

const refundType = (props) => {
    let refundable = null;
    const FS = props.FS;

    if (FS[0].ft === "1") {
      refundable = "Refundable";
    } else if (FS[0].ft === "0") {
      refundable = "Non Refundable"
    }

    return <span className={classes.RefundType}>{refundable}</span>
}

export default refundType;


// WEBPACK FOOTER //
// ./src/components/Flight/Airline/AirlineRefundable/AirlineRefundable.js